import React, { useEffect, useState, useRef } from "react";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
// import { Chart } from "chart.js/auto";
import Loader from "../../../Loader/Loader";
import {
    Chart,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import moment from "moment";
import Comments from "../Comments/Comment";
import { compName } from "../../../../utils/constant";
import { Col, Container, Form, Row, Table, Button } from "react-bootstrap";
import WidgetDetailModal from "../../WidgetDetailModal";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
const BookingPaceMonthlyForecast = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const widgetDetailRef = useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState(null);


    const getChartData = async () => {
        const date = new Date();
        const startDate = commonService.getDateInDBFormat(
            new Date(date.getFullYear(), date.getMonth(), 1)
        );
        const endDate = commonService.getDateInDBFormat(
            new Date(date.getFullYear(), date.getMonth() + 1, 0)
        );
        setLoading(true);
        let chartDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.BOOKING_PACE.COMPARISON_CHART,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, chartDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let chartDataset = {
                label: [],
                min: {
                    label: "Min",
                    backgroundColor: "#156082",
                    borderColor: "#156082",
                    data: [],
                    stack: "stack1",
                },
                max: {
                    label: "Max",
                    backgroundColor: "#196B24",
                    borderColor: "#196B24",
                    data: [],
                    stack: "stack2",
                },
                Avg: {
                    label: "Avg",
                    backgroundColor: "#E97132",
                    borderColor: "#E97132",
                    data: [],
                    stack: "stack3",
                },
                OTB: {
                    label: "OTB",
                    backgroundColor: "#0F9ED5",
                    borderColor: "#0F9ED5",
                    data: [],
                    stack: "stack4",
                },
            };

            function getWeekNumberOfMonth(date) {
                if (!(date instanceof Date)) {
                    date = new Date(date);
                }

                const firstDayOfMonth = new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    1
                );

                const firstDayWeekDay = firstDayOfMonth.getDay();

                const currentDayOfMonth = date.getDate();

                const weekNumber = Math.ceil((currentDayOfMonth + firstDayWeekDay) / 7);

                let dateRange = commonService.getWeekStartAndEndDate(date);

                if (weekNumber === 1) {
                    dateRange.start = firstDayOfMonth;
                }

                if (new Date(dateRange.end).getMonth() !== new Date().getMonth()) {
                    dateRange.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                }

                // return weekNumber;
                return `${moment(dateRange?.start).format("MM/DD")}-${moment(
                    dateRange?.end
                ).format("MM/DD")}`;
            }

            let weeksArrData = {};

            dataFromApi?.forEach((item) => {
                let weekNumber = getWeekNumberOfMonth(item?.staydate + " 00:00:00");
                if (weeksArrData[weekNumber]) {
                    weeksArrData[weekNumber] = [...weeksArrData[weekNumber], item];
                } else {
                    weeksArrData[weekNumber] = [item];
                }
            });

            Object.entries(weeksArrData).map(([key, value]) => {
                let max = value?.[0]?.forcastroom,
                    min = value?.[0]?.forcastroom,
                    avgTotal = 0,
                    otbTotal = 0;
                value?.forEach((valueItem) => {
                    max = max < valueItem?.forcastroom ? valueItem?.forcastroom : max;
                    min = min > valueItem?.forcastroom ? valueItem?.forcastroom : min;
                    avgTotal =
                        avgTotal + (valueItem?.forcastroom ? valueItem?.forcastroom : 0);
                    otbTotal =
                        otbTotal +
                        (valueItem?.total_booking ? valueItem?.total_booking : 0);
                });
                // chartDataset.label.push(`W-${key}`);
                chartDataset.label.push(`${key}`);
                chartDataset.min.data.push(min);
                chartDataset.max.data.push(max);
                chartDataset.Avg.data.push(Math.round(avgTotal / value?.length));
                chartDataset.OTB.data.push(Math.round(otbTotal / value?.length));
            });

            setChartData({
                labels: chartDataset?.label,
                datasets: [
                    chartDataset?.min,
                    chartDataset?.max,
                    chartDataset?.Avg,
                    chartDataset?.OTB,
                ],
            });
            setLoading(false);
        }

        if (!response?.isValidate) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getChartData();
            }
        }
    }, [para?.asOfDate]);



    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: false,
                text: "Chart.js Line Chart",
            },
            tooltip: {
                mode: "index",
                intersect: false,
                callbacks: {
                    label: function (tooltipItem) {
                        return tooltipItem.dataset.label + ": " + tooltipItem.raw;
                    },
                },
            },
        },
    };

    Chart.register(
        ArcElement,
        Tooltip,
        Legend,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Filler
    );

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">

                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("BookingPaceMonthlyForecast", "info", "")}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.BookingPaceMonthlyForecast,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>

                </div>
            )}
            <div>
                {loading ? (
                    <Loader />
                ) : chartData ? (

                    <div style={{ height: "400px" }}>
                        <Line data={chartData} options={chartOptions} />
                    </div>
                ) : (
                    <div>
                        <p>No Data Found</p>
                    </div>
                )}
                {api !== 0 && (
                    <Comments
                        widgetDetails={para}
                        editorId={"BookingPaceMonthlyForecast"}
                    />
                )}
            </div>
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>

    );
};

export default BookingPaceMonthlyForecast;
